export default __webpack_public_path__ + "static/media/ISStracker-homepage-screenshot.1012701b.png";